var _path;

import * as React from "react";

function SvgArrowFilter(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.434 22.572h19.131c1.72 0 2.58 2.082 1.367 3.296l-9.566 9.565a1.921 1.921 0 01-2.725 0l-9.573-9.565c-1.214-1.214-.354-3.296 1.366-3.296zm20.498-8.44l-9.566-9.565a1.921 1.921 0 00-2.725 0l-9.573 9.565c-1.214 1.214-.354 3.296 1.366 3.296h19.131c1.72 0 2.58-2.082 1.367-3.296z"
  })));
}

export default SvgArrowFilter;